import React from 'react';

function Header() {
  return (
    <header id="header"> <a className="logo" href="/">Reliance Litigation</a>
        <nav> <a href="#menu">Menu</a> </nav>
    </header>
  );
}

export default Header;